import { createBaseApi } from '../baseApi';

const licensingApi = createBaseApi('licensingApi');

export const enhancedLicensingApi = licensingApi.injectEndpoints({
  endpoints: (builder) => ({
    purchaseLicense: builder.mutation({
      query: ({ listingId, itemType, savedPaymentMethodId }) => ({
        url: '/license/purchase',
        method: 'POST',
        body: { listingId, itemType, savedPaymentMethodId }
      })
    }),
    confirmLicense: builder.mutation({
      query: ({ paymentIntentId }) => ({
        url: '/license/confirm',
        method: 'POST',
        body: { paymentIntentId }
      }),
      invalidatesTags: (result, error, arg) => ['License', 'VtoResult']
    }),
    getMyLicenses: builder.query({
      query: () => '/license/mine',
      transformResponse: (response) => response.licenses || [],
      providesTags: ['License']
    }),
    checkLicense: builder.query({
      query: ({ listingId, itemType }) => `/license/check/${listingId}?itemType=${itemType || 'listing'}`,
      transformResponse: (response) => ({
        hasLicense: response.hasLicense || false,
        license: response.license || null
      }),
      providesTags: (result, error, arg) => [{ type: 'License', id: arg.listingId || arg }]
    })
  }),
  overrideExisting: false
});

export const {
  usePurchaseLicenseMutation,
  useConfirmLicenseMutation,
  useGetMyLicensesQuery,
  useCheckLicenseQuery
} = enhancedLicensingApi;

export default enhancedLicensingApi;
